<template>
    <div class='card'>
        <DynamicImageContainer class="thumbnail" :image='product.main_picture' />
        <div>{{product.product}}</div>
        <div>£{{product.price}}</div>
    </div>
</template>

<script>
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
export default {
    components: {DynamicImageContainer}, 
    props: ['product'],
}
</script>

<style lang="scss" scoped>
.card{
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 250px;
}
.thumbnail{
    width: 250px;
    height: 250px;
    object-fit: cover;
    object-position: 50% 0;
    cursor: pointer;

    @media (max-width: 768px) {
        width: 300px;
        height: 300px;
    }
}
</style>